import { useSession as nextAuthUseSession } from 'next-auth/react'

import { useGetUserAuthStateQuery } from '@/generated'

import { isUserAuthenticated, isUserSessionLoading } from '../domain/user'

/**
 * Custom hook to get the user session.
 * It combines the session from next-auth and our own
 * custom auth logic, to return them both.
 *
 * Ideally, we should expose booleans like `isAuthenticated`,
 * `isUserLoading`, `isUnauthenticated`, `optimisticIsAuthenticated`
 * and remove next-auth's own `status` string from the return.
 */
export const useSession = () => {
  const nextAuthUseSessionReturn = nextAuthUseSession()

  const { data } = useGetUserAuthStateQuery()
  const isServerAuthenticated = !!data?.userAuthState.isMiddlewareAuthenticated
  const optimisticIsAuthenticated = isUserSessionLoading(nextAuthUseSessionReturn.status)
    ? isServerAuthenticated
    : isUserAuthenticated(nextAuthUseSessionReturn.status)

  return { ...nextAuthUseSessionReturn, optimisticIsAuthenticated }
}
